module.exports = __webpack_public_path__ + "img/cxTrends-9.1a90a88c.png";